export const GLOBAL_DELETE = "GLOBAL_DELETE";
export const GLOBAL_CANCEL = "GLOBAL_CANCEL";
export const GLOBAL_UNKNOWN = "GLOBAL_UNKNOWN";
